export const CONFIG = {
    baseURL: "https://portfolio-backend.sdslabs.co",
    colors: ["blue", "red", "green", "yellow", "purple", "orange"],
    mobileSize: 576
};
